/**
 * timeout helper.
 *
 * @copyright Realeyes OU. All rights reserved.
 */


/**
 * Rejects a pending promise after a specified timeout.
 *
 * @param {number} ms Number of milliseconds to wait before the call will be rejected
 * @param {Promise} promise Promise to execute
 * @return {Promise}
 */
export default function timeout(ms, promise) {
    let pending = true;

    return Promise.race([
        promise.then((v) => { pending = false; return v; }),
        new Promise((_, reject) => setTimeout(() => {
            if (pending) {
                reject('timeout');
            }
        }, ms)),
    ]);
}
